var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStairCase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#232A2E;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "43.03,30.34 43.03,43.87 6.97,43.87 6.97,30.34 18.95,3.26 31.24,3.26  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M43.03,44.38H6.97c-0.28,0-0.51-0.23-0.51-0.51V30.34c0-0.07,0.01-0.14,0.04-0.21L18.49,3.06 c0.08-0.18,0.26-0.3,0.47-0.3h12.28c0.2,0,0.39,0.12,0.47,0.31l11.8,27.08c0.03,0.06,0.04,0.13,0.04,0.2v13.53 C43.54,44.15,43.31,44.38,43.03,44.38z M7.48,43.36h35.04V30.45L30.9,3.77H19.28L7.48,30.45V43.36z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "31.11,3.26 32.29,7.48 17.72,7.48 18.89,3.26  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32.29,7.99H17.72c-0.16,0-0.31-0.07-0.41-0.2c-0.1-0.13-0.13-0.29-0.08-0.44l1.17-4.21 c0.06-0.22,0.26-0.37,0.49-0.37h12.22c0.23,0,0.43,0.15,0.49,0.37l1.17,4.21c0.04,0.15,0.01,0.32-0.08,0.44 C32.6,7.91,32.44,7.99,32.29,7.99z M18.39,6.97h13.23l-0.89-3.2H19.28L18.39,6.97z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "37.45,34.93 40.25,41.83 9.76,41.83 12.56,34.93  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M40.25,42.34H9.76c-0.17,0-0.33-0.08-0.42-0.22c-0.09-0.14-0.11-0.32-0.05-0.48l2.8-6.9 c0.08-0.19,0.26-0.32,0.47-0.32h24.9c0.21,0,0.39,0.13,0.47,0.32l2.8,6.9c0.06,0.16,0.05,0.33-0.05,0.48 C40.58,42.26,40.42,42.34,40.25,42.34z M10.51,41.32h28.98l-2.39-5.88H12.9L10.51,41.32z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 9.75,
    y: 41.83,
    className: "st1",
    width: 30.49,
    height: 4.91
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M40.24,47.25H9.75c-0.28,0-0.51-0.23-0.51-0.51v-4.91c0-0.28,0.23-0.51,0.51-0.51h30.49 c0.28,0,0.51,0.23,0.51,0.51v4.91C40.75,47.02,40.52,47.25,40.24,47.25z M10.26,46.23h29.48v-3.89H10.26V46.23z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "35.34,26.07 37.6,31.09 12.41,31.09 14.66,26.07  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M37.6,31.6H12.41c-0.17,0-0.33-0.09-0.43-0.23s-0.11-0.33-0.04-0.49l2.26-5.02c0.08-0.18,0.26-0.3,0.46-0.3 h20.68c0.2,0,0.38,0.12,0.46,0.3l2.26,5.02c0.07,0.16,0.06,0.34-0.04,0.49C37.93,31.51,37.77,31.6,37.6,31.6z M13.19,30.58 h23.62l-1.8-4H14.99L13.19,30.58z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 12.4,
    y: 31.09,
    className: "st1",
    width: 25.19,
    height: 3.84
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M37.59,35.44H12.4c-0.28,0-0.51-0.23-0.51-0.51v-3.84c0-0.28,0.23-0.51,0.51-0.51h25.2 c0.28,0,0.51,0.23,0.51,0.51v3.84C38.1,35.21,37.88,35.44,37.59,35.44z M12.91,34.42h24.18V31.6H12.91V34.42z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "33.61,18.47 35.42,22.68 14.58,22.68 16.4,18.47  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M35.42,23.19H14.58c-0.17,0-0.33-0.09-0.42-0.23c-0.09-0.14-0.11-0.32-0.04-0.48l1.81-4.21 c0.08-0.19,0.26-0.31,0.47-0.31h17.21c0.2,0,0.39,0.12,0.47,0.31l1.81,4.21c0.07,0.16,0.05,0.34-0.04,0.48 C35.75,23.11,35.59,23.19,35.42,23.19z M15.35,22.17h19.3l-1.38-3.2H16.73L15.35,22.17z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 14.58,
    y: 22.68,
    className: "st1",
    width: 20.84,
    height: 3.39
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M35.42,26.58H14.58c-0.28,0-0.51-0.23-0.51-0.51v-3.39c0-0.28,0.23-0.51,0.51-0.51h20.84 c0.28,0,0.51,0.23,0.51,0.51v3.39C35.93,26.36,35.7,26.58,35.42,26.58z M15.09,25.57h19.82v-2.37H15.09V25.57z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "32.21,10.87 33.66,15.08 16.34,15.08 17.8,10.87  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M33.66,15.59H16.34c-0.16,0-0.32-0.08-0.41-0.21c-0.1-0.13-0.12-0.31-0.07-0.46l1.46-4.21 c0.07-0.21,0.26-0.34,0.48-0.34h14.41c0.22,0,0.41,0.14,0.48,0.34l1.46,4.21c0.05,0.16,0.03,0.33-0.07,0.46 C33.98,15.51,33.82,15.59,33.66,15.59z M17.06,14.57h15.89l-1.1-3.2H18.16L17.06,14.57z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 16.34,
    y: 15.08,
    className: "st1",
    width: 17.32,
    height: 3.39
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M33.66,18.98H16.34c-0.28,0-0.51-0.23-0.51-0.51v-3.39c0-0.28,0.23-0.51,0.51-0.51h17.32 c0.28,0,0.51,0.23,0.51,0.51v3.39C34.17,18.75,33.94,18.98,33.66,18.98z M16.85,17.96h16.3v-2.37h-16.3V17.96z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "18.95,3.26 6.97,30.35 3.29,30.35 16.27,3.26  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M6.97,30.86H3.29c-0.17,0-0.34-0.09-0.43-0.24c-0.09-0.15-0.1-0.33-0.03-0.49L15.81,3.04 c0.08-0.18,0.26-0.29,0.46-0.29h2.68c0.17,0,0.33,0.09,0.43,0.23c0.09,0.14,0.11,0.33,0.04,0.48L7.44,30.55 C7.36,30.74,7.17,30.86,6.97,30.86z M4.1,29.84h2.54L18.17,3.77h-1.58L4.1,29.84z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.51,
    y: 43.87,
    className: "st0",
    width: 9.25,
    height: 2.87
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M9.76,47.25H0.51C0.23,47.25,0,47.02,0,46.74v-2.87c0-0.28,0.23-0.51,0.51-0.51h9.25 c0.28,0,0.51,0.23,0.51,0.51v2.87C10.27,47.02,10.04,47.25,9.76,47.25z M1.02,46.23h8.23v-1.85H1.02V46.23z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 3.29,
    y: 30.34,
    className: "st1",
    width: 3.68,
    height: 13.52
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M6.97,44.38H3.29c-0.28,0-0.51-0.23-0.51-0.51V30.34c0-0.28,0.23-0.51,0.51-0.51h3.68 c0.28,0,0.51,0.23,0.51,0.51v13.52C7.48,44.15,7.26,44.38,6.97,44.38z M3.8,43.36h2.67V30.85H3.8V43.36z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 40.24,
    y: 43.87,
    className: "st0",
    width: 9.25,
    height: 2.87
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M49.49,47.25h-9.25c-0.28,0-0.51-0.23-0.51-0.51v-2.87c0-0.28,0.23-0.51,0.51-0.51h9.25 c0.28,0,0.51,0.23,0.51,0.51v2.87C50,47.02,49.77,47.25,49.49,47.25z M40.75,46.23h8.23v-1.85h-8.23V46.23z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 43.03,
    y: 30.34,
    className: "st1",
    width: 3.68,
    height: 13.52
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M46.71,44.38h-3.68c-0.28,0-0.51-0.23-0.51-0.51V30.34c0-0.28,0.23-0.51,0.51-0.51h3.68 c0.28,0,0.51,0.23,0.51,0.51v13.52C47.22,44.15,46.99,44.38,46.71,44.38z M43.53,43.36h2.67V30.85h-2.67V43.36z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "31.24,3.26 43.03,30.35 46.71,30.35 33.92,3.26  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M46.71,30.86h-3.68c-0.2,0-0.39-0.12-0.47-0.31L30.77,3.47c-0.07-0.16-0.05-0.34,0.04-0.48 c0.09-0.14,0.25-0.23,0.43-0.23h2.68c0.2,0,0.38,0.11,0.46,0.29l12.79,27.09c0.07,0.16,0.06,0.34-0.03,0.49 C47.04,30.77,46.88,30.86,46.71,30.86z M43.36,29.84h2.54L33.59,3.77h-1.58L43.36,29.84z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 17.71,
    y: 7.48,
    className: "st1",
    width: 14.57,
    height: 3.39
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32.28,11.38H17.71c-0.28,0-0.51-0.23-0.51-0.51V7.47c0-0.28,0.23-0.51,0.51-0.51h14.57 c0.28,0,0.51,0.23,0.51,0.51v3.39C32.79,11.15,32.56,11.38,32.28,11.38z M18.22,10.36h13.55V7.98H18.22V10.36z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStairCase);
export default __webpack_public_path__ + "static/media/stair-case.1b8fd998f2614ebdea194a79762bb5cf.svg";
export { ForwardRef as ReactComponent };